import { readZReports } from "@prostocheck/fiscal";
import {
  IDateRange,
  IFiscalClient,
  IZReport,
  SimpleResult,
} from "@prostocheck/shared";

export interface IZReportsQuery extends IDateRange {
  client: IFiscalClient;
  cashRegisterFn: string;
}

/**
 * Z-reports of a register over a period, newest first. Bounded by design: ДПС
 * has no command that lists reports without a date range — see
 * ai/docs/prro-api.md.
 */
export const fetchZReports = ({
  client,
  cashRegisterFn,
  from,
  to,
}: IZReportsQuery): Promise<SimpleResult<IZReport[]>> =>
  readZReports({ client, registrarFiscalNumber: cashRegisterFn, from, to });
